import { render, staticRenderFns } from "./Pic.vue?vue&type=template&id=5b3afc8d&scoped=true&"
import script from "./Pic.vue?vue&type=script&lang=js&"
export * from "./Pic.vue?vue&type=script&lang=js&"
import style0 from "./Pic.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Pic.vue?vue&type=style&index=1&id=5b3afc8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3afc8d",
  null
  
)

export default component.exports